import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

export const clinicSettingsValidationSchema = () =>
  createValidationSchema({
    status: commonValidationSchemas.string(),
    showOnInteractiveTimeDashboard: commonValidationSchemas.boolean(),
    acceptBingoStatus: commonValidationSchemas.boolean(),
    adherenceSmsSubscription: commonValidationSchemas.boolean(),
    reviewTimeSeconds: commonValidationSchemas.number(),
    updateChildrenReviewTime: commonValidationSchemas.boolean(),
  });
